import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { CloseIcon } from '@icons';
import { IEventNotificationView } from './interfaces';

import NotificationButton from '@components/Notification/NotificationButton';
import { useStyles as useDefaultNotificationStyle } from '@components/Notification/styles';

const notificationClasses = {
  buttonsContainer: {
    flexDirection: 'row',
    gap: 1,
  },
};

const LeaveStyleStudioEventNotificationView = React.forwardRef<
  HTMLDivElement,
  IEventNotificationView
>(
  (
    {
      message,
      color,
      colorIcon,
      background,
      icon: Icon,
      onLeave,
      onClickClose,
    },
    ref,
  ) => {
    const hasIcon = !!Icon;
    const classes = useDefaultNotificationStyle({
      color,
      hasIcon,
      colorIcon,
      background,
    });
    const { t: translate } = useTranslation();

    return (
      <Box ref={ref} sx={classes.root}>
        <Box sx={classes.iconContainer}>
          {Icon ? <Icon sx={classes.icon} /> : null}
          <CloseIcon sx={classes.closeIcon} onClick={onClickClose} />
        </Box>
        <Typography sx={classes.title}>{message}</Typography>
        <Box
          sx={{
            ...classes.buttonsContainer,
            ...notificationClasses.buttonsContainer,
          }}
        >
          <NotificationButton onClick={onClickClose} color={color}>
            {translate('styleStudio.cancelButton')}
          </NotificationButton>
          <NotificationButton onClick={onLeave} color={color} primary>
            {translate('styleStudio.leaveButton')}
          </NotificationButton>
        </Box>
      </Box>
    );
  },
);

export default LeaveStyleStudioEventNotificationView;
